export default class CartEntity {
    constructor (data) {
        return data;
    }

}